var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "WebPlayer",
    { ref: "webPlayer", attrs: { "on-player-event": _vm.onPlayerEvent } },
    [
      _c("WebPlayerFeedback", {
        ref: "webPlayerFeedback",
        attrs: { "on-submit-password": _vm.onSubmitPassword },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }